import { library } from "@fortawesome/fontawesome-svg-core";
import {
  faHome,
  faBus,
  faFilePdf,
  faFileCsv,
  faFileImage,
  faFileArrowDown,
  faImage,
  faFileExcel,
  faList,
  faIdCard,
  faRoute,
  faPlayCircle
} from "@fortawesome/free-solid-svg-icons";

library.add(
  faHome,
  faBus,
  faFilePdf,
  faFileCsv,
  faFileImage,
  faFileArrowDown,
  faImage,
  faFileExcel,
  faList,
  faIdCard,
  faRoute,
  faPlayCircle
);

// import "@fortawesome/fontawesome-free/js/fontawesome";
// import "@fortawesome/fontawesome-free/js/solid";
